export default {
  cake: {
    56: '0x4a162e9a102d2195c1c4bf3bd319ad25a895ccaf',
    97: '0xeb44841d356b706684460eef19c7e577986bd637',
  },
  masterChef: {
    56: '0xd69d858e32438a44fb5cba7a4619970fb0746654',
    97: '0xbd13029c6cf665f8058cfec5fd26b423a9e16519',
  },
  sousChef: {
    97: '0xd3af5fe61dbaf8f73149bfcfa9fb653ff096029a',
    56: '0x6ab8463a4185b80905e05a9ff80a2d6b714b9e95',
  },
  wbnb: {
    56: '0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c',
    97: '0xae13d989dac2f0debff460ac112a837c89baa7cd',
  },
  lottery: {
    56: '0x4ee3aed30e4bf5f3f63c4dada9f7840bfd96f058',
    97: '0xf77c871436d55d84840b6f265d474c29aa1c9890',
  },
  lotteryNFT: {
    56: '0xf1200171ddb0cd2315dde74b0d6a03ca31dfb783',
    97: '0xd340b3d5e4a7f4c8fc391cf63e10d56e3689021f',
  },
  mulltiCall: {
    56: '0x1ee38d535d541c55c9dae27b12edf090c608e6fb',
    97: '0x6ab4e5cd7561d105399308250f71bb8d9ae2dc91',
  },
  busd: {
    56: '0xe9e7cea3dedca5984780bafc599bd69add087d56',
    97: '0xE0dFffc2E01A7f051069649aD4eb3F518430B6a4',
  },
    usdt: {
    56: '0x55d398326f99059ff775485246999027b3197955',
    97: '0x7afd064DaE94d73ee37d19ff2D264f5A2903bBB0',
  },
    like: {
    56: '0x4a162e9a102d2195c1c4bf3bd319ad25a895ccaf',
    97: '0xeb44841d356b706684460eef19c7e577986bd637',
  },
  referral: {
    56: '0xa1b19b4dc636542479c51b3d310684d45e563c88',
    97: '0x940eb395d4398a12aa897e25bd335ed5ac3c8b26',
  },
}
